import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from '../../../assets/jss/coscef/components/customCircularProgressStyle';

const useStyles = makeStyles(styles);
const defaultSize = 50;

export default function CircularIndeterminate(props) {
  const { variant, color, size, className } = props;

  const classes = useStyles();

  const spinnerClasses = classNames({
    [classes[variant]]: variant,
    [classes[color]]: color,
    [classes[size]]: size,
    [className]: className,
  });

  return (
    <div className={classes.root}>
      <CircularProgress className={spinnerClasses} />
    </div>
  );
}

CircularIndeterminate.defaultProps = {
  variant: null,
  color: 'primary',
  size: defaultSize,
};

CircularIndeterminate.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'warning',
    'danger',
    'success',
    'info',
    'rose',
    'gray',
  ]),
  size: PropTypes.number,
  className: PropTypes.string,
};
